module.exports = __webpack_public_path__ + "img/LOGO.1e4a3ef6.png";